<template>
  <private-template>
    <template v-slot:private-template>
      <div class="Users viewContainer">
        <TitleView title="Compañias"/>
        <div class="viewContainer__content">
          <CompaniesBlock />
        </div>
      </div>
    </template>
  </private-template>
</template>

<script>
import TitleView from '@/components/atoms/TitleView/TitleView.vue';
import PrivateTemplate from '@/templates/PrivateTemplate.vue';
import CompaniesBlock from '@/components/molecules/Companies/CompaniesBlock.vue';

export default {
  name: 'Companies',
  components: {
    PrivateTemplate,
    TitleView,
    CompaniesBlock,
  },
};
</script>
